/**
* Nom : documentNew.js
* Description : Ce fichier contient la définition de la page documentNew 
*               Cette page fourni un formulaire pour créer un document
* Date de création : 25 septembre 2025
*/

/* CSS et assets */
// None

/* Bibliothèques et composants */
import { CompanyBar } from 'package_ui_ihm/dist'
import { TabC } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { BackPage } from 'package_ui_ihm/dist'
import { SelectForm} from 'package_ui_ihm/dist'
import { FileForm } from 'package_ui_ihm/dist'

/* Hook */
import { useState, useEffect } from 'react'
import { useBlocker } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useNavigate } from 'react-router-dom'
import { useScreenWidth } from 'package_ui_ihm/dist'


/**
* DocumentNew : affiche une page avec un formulaire pour créer un document
*               un lien permet de revenir sur la page qui liste tous les documents
*
* Type : page 
*
* Parametres : 
*  None
*/
function DocumentNew() {

    // Define useState hooks
    const [file, setFile] = useState(null);
    const [selectedVersion, setSelectedVersion] = useState(0);
    const [selectedProduct, setSelectedProduct] = useState(0)
    const [selectedDocumentType, setSelectedDocumentType] = useState(0);
    const [statusDocument, setStatusDocument] = useState(null)
    const [products, setProducts] = useState([])
    const [documentTypes, setDocumentTypes] = useState([])
    const [versions, setVersions] = useState([{id: 1, name: '1'}])
    const [fileError, setFileError] = useState(false);
    const [versionError, setVersionError] = useState(false);
    const [documentTypeError, setDocumentTypeError] = useState(false);
    const [productError, setProductError] = useState(false);
    const [formSubmit, setFormSubmit] = useState(false);
    const [skipPrompt, setSkipPrompt] = useState(false);


    // Define useContext hooks
    const { authStatus, authToken } = useAuth();
    const { path } = useApi();

    const navigate = useNavigate();


    // Define useBlocker hooks
    const shouldBlock = 
        ((selectedProduct !== "0" && selectedProduct !== 0) || 
        (selectedVersion !== "0" && selectedVersion !== 0) || 
        (selectedDocumentType !== "0" && selectedDocumentType !== 0) ||
        (file !== null && file !== '')) && 
        (skipPrompt === false);
    const blocker = useBlocker(shouldBlock);


    // Define useScreenWidth hooks
    const screenWidth = useScreenWidth();


    // Define functions
    async function sendData(file, product_id, version, document_type_id) {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("file", file, file.name);
        form_data.append("product_id",  Number(product_id));
        form_data.append("version", version);
        form_data.append("document_type_id",  Number(document_type_id));
        // Create Document
        const response = await fetch(path + "/api/eq-dont/", 
            {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        )
        setStatusDocument(response["status"])
        setFormSubmit(false)
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setSkipPrompt(true);
        // Check of data for document
        if(file === null || file === ''){
            setFileError(true)
        }
        else
        {   
            setFileError(false)
        }
        //if(version === null || version === ''){
        if(selectedVersion === 0 || selectedVersion === '0'){
            setVersionError(true)
        }
        else
        {   
            setVersionError(false)
        }
        if(selectedProduct === 0 || selectedProduct === '0'){
            setProductError(true)
        }
        else
        {   
            setProductError(false)
        }
        if(selectedDocumentType === 0 || selectedDocumentType === '0'){
            setDocumentTypeError(true)
        }
        else
        {   
            setDocumentTypeError(false)
        }
        setFormSubmit(true)
    };

    async function retrieveData() {
        // Token
        const token = "Bearer " + authToken
        // Headers
        const headers = {
            accept: 'application/json',
            Authorization: token,
        }
        // Requests in parallel to win time 
        const [resProduct, resDocumentType] = await Promise.all([
            // Products
            fetch(path + "/api/eq-prct/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Document Types
            fetch(path + "/api/eq-doty/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
        ])
        // Responses in parallel to win time
        const [dataProduct, dataDocumentType] = await Promise.all([
            resProduct.json(),
            resDocumentType.json(),
        ])
        // Set variables
        setProducts(dataProduct["results"])
        setDocumentTypes(dataDocumentType["results"])
        // Versions
        var dataVersion
        if(Number(selectedProduct) !== 0)
        {
            const resVersion = await fetch(path + "/api/eq-prve/?product_id=" + selectedProduct, 
                {
                    method: 'GET',
                    credentials: 'include',
                    mode: 'cors',
                    headers,
                }
            );
            dataVersion = await resVersion.json();
            setVersions(dataVersion["results"])
        } 
    }

    async function retrieveVersions() {
        // Token
        const token = "Bearer " + authToken
        // Versions
        if(Number(selectedProduct) !== 0)
        {
            const resVersion = await fetch(path + "/api/eq-prve/?product_id=" + selectedProduct, 
                {
                    method: 'GET',
                    credentials: 'include',
                    mode: 'cors',
                    headers: {
                        accept: 'application/json',
                        Authorization: token,
                    },
                }
            );
            const dataVersion = await resVersion.json();
            setVersions(dataVersion["results"])
        } 
    }

    function handleFile (event) {
        const file = event.target.files[0];
        setFile(file);
    };


    // Define useEffect hooks
    useEffect(() => {
        if(authStatus === 200)
        {
            retrieveData()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        retrieveVersions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedProduct])

    useEffect(() => {
        if(formSubmit === true && fileError === false && versionError === false && productError === false && documentTypeError === false){
            sendData(file, selectedProduct, versions.find(version => version.id === Number(selectedVersion))['name'], selectedDocumentType)
        } else {
            setSkipPrompt(false);
            setFormSubmit(false)
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [formSubmit])

    useEffect(() => {
        if(statusDocument === 201) {
            navigate('/documents/')
        } else {
            setFormSubmit(false)
            navigate('/documents/new')
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusDocument, navigate]);

    useEffect(() => {
        // Bloquer la fermeture d'onglet/rafraîchissement
        const handleBeforeUnload = (e) => {
            if (shouldBlock === true) {
                // Standard pour afficher une confirmation (les navigateurs modernes gèrent le message)
                e.preventDefault();
                e.returnValue = "";
                // Certains navigateurs nécessitent cette ligne pour afficher la confirmation
                return (e.returnValue = "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées.");
            }
        }; 

        window.addEventListener("beforeunload", handleBeforeUnload);

        // Nettoyer l'écouteur quand le composant est démonté
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldBlock]);

    useEffect(() => {
        if (blocker.state === "blocked") {
            const confirmed = window.confirm(
                "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées."
            );

            if (confirmed) {
                blocker.proceed();
            } else {
                blocker.reset();
            }
        }
    }, [blocker]);


    // Render component
    return (
        <div>
            <CompanyBar name_app="BOXIBRAIN"/>
            <TabC tabNumber={1}/>
            <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
                <Container>
                    <h1>Créer un nouveau document</h1>
                    {/*Lien de retour*/}
                    <div className='flex-row justify-start margin-left margin-bottom margin-top'>
                        <div className='link-border'>
                            <BackPage path='/documents'>Retour à la liste des documents</BackPage>
                        </div>
                    </div>
                    {(statusDocument !== null && statusDocument !== 201 && fileError === false && productError === false && versionError === false && documentTypeError === false) ? (
                        <p className='form-error'>Le document existe déjà ou n'a pas pu être enregistré !</p>
                    ) : (
                        <p/>
                    )}  
                    <form onSubmit={handleSubmit} className='flex-column'>
                        <div className='flex-column form-center'>
                            <FileForm error={fileError} label="Modifier le fichier" onChangeFunc={handleFile} currentValue={null}/>
                            <SelectForm error={productError} labelText='Produit' choices={products.sort((a, b) => (a.name > b.name)?1:-1)} selectedItem={selectedProduct} setSelectedItem={setSelectedProduct}/>                       
                            <SelectForm error={versionError} labelText='Version du produit' choices={versions} selectedItem={selectedVersion} setSelectedItem={setSelectedVersion}/>
                            <SelectForm error={documentTypeError} labelText='Type de document' choices={documentTypes} selectedItem={selectedDocumentType} setSelectedItem={setSelectedDocumentType}/>
                        </div>
                        <div className='flex-column form-right'>
                            <button type="submit" className='button'>Valider</button>
                        </div>
                    </form> 
                </Container>
            </div>
        </div>
    );
}

export default DocumentNew;
